var map = {
	"./ICEMR_image.jpg": 383,
	"./ICEMR_image_th.jpg": 384,
	"./Ivermectin_for_malaria_elimination_image.jpg": 385,
	"./Ivermectin_for_malaria_elimination_image_th.jpg": 386,
	"./MMV_award_image.jpg": 387,
	"./MMV_award_image_th.jpg": 388,
	"./councilor_image.jpg": 389,
	"./councilor_image_th.jpg": 390
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 397;



//////////////////
// WEBPACK FOOTER
// ./src/images/news nonrecursive \.(jpe?g)$
// module id = 397
// module chunks = 22846268747618 46636455185173